import {
	GEO_COMPLY_RESULT_KEY,
	parseLocateDeviceResult,
	serializeLocateDeviceResult,
} from './geo-result-serialization'
import type { GeoLocationResult } from './geo-failure-reason'

export interface GeoResultStorage {
	write(result: GeoLocationResult): void
	read(): LocateDeviceResult | null
	clear(): void
}

export function createGeoResultStorage(storage: Storage): GeoResultStorage {
	return {
		write(result: GeoLocationResult): void {
			storage.setItem(GEO_COMPLY_RESULT_KEY, serializeLocateDeviceResult(result))
		},
		read(): LocateDeviceResult | null {
			const json = storage.getItem(GEO_COMPLY_RESULT_KEY)
			if (json === null) return null
			return parseLocateDeviceResult(json)
		},
		clear(): void {
			storage.removeItem(GEO_COMPLY_RESULT_KEY)
		},
	}
}
